import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { HomePage } from "./pages/HomePage";
import {
  AboutPage,
  DelegatedPage,
  DevelopersPage,
  GatewayPage,
  NetworkPage,
  ProtocolPage,
  ReceiptsPage,
  RoadmapPage,
  SecurityPage,
  WhitepaperPage,
} from "./pages/ContentPages";
import { ContactPage } from "./pages/HomePage";
import "./styles.css";

function RouteManager() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    document.title = "ORIQ | Trusted Agent Infrastructure";
  }, [location.pathname, location.hash]);
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/gateway" element={<GatewayPage />} />
        <Route path="/delegated-action-control" element={<DelegatedPage />} />
        <Route path="/action-receipts" element={<ReceiptsPage />} />
        <Route path="/protocol" element={<ProtocolPage />} />
        <Route path="/network" element={<NetworkPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/roadmap" element={<RoadmapPage />} />
        <Route path="/whitepaper" element={<WhitepaperPage />} />
        <Route path="/developers" element={<DevelopersPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </AppShell>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <RouteManager />
    </BrowserRouter>
  );
}
